import { createSlice } from '@reduxjs/toolkit'

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    pdfViewer: 'close',
    activeDevices: 'close',
    sendOtp: 'close',
    addPayment: 'close',
    robotSmsCredits: 'close',
    organizerSettingsEventFeePercent: 'close',
    downloadReport: 'close',
    organizerSettings: 'close',
    cancelTicket: 'close',
    cancelTicketByUuid: 'close',
    transactionAction: 'close',
    declineRequestAction: 'close',
    approveRequestAction: 'close',
    eventCrossQRScanner: 'close',
    eventGiftTickets: 'close',
    changeEventOwner: 'close',
    eventSettings: 'close',
    eventTypes: 'close',
    changeOwnerByLink: 'close',
    organizerFiles: 'close',
    uploadOrganizerFile: 'close',
    createTransaction: 'close',
    billAccount: 'close',
    sendPushNotification: 'close',
    sendSmsBroadcast: 'close',
  },
  reducers: {
    toggleActiveDevicesModal(state) {
      return { ...state, activeDevices: state.activeDevices === 'open' ? 'close' : 'open' }
    },
    toggleSendOtpModal(state) {
      return { ...state, sendOtp: state.sendOtp === 'open' ? 'close' : 'open' }
    },
    toggleAddPaymentModal(state) {
      return { ...state, addPayment: state.addPayment === 'open' ? 'close' : 'open' }
    },
    togglePdfViewerModal(state) {
      return { ...state, pdfViewer: state.pdfViewer === 'open' ? 'close' : 'open' }
    },
    toggleRobotSmsCreditsModal(state) {
      return { ...state, robotSmsCredits: state.robotSmsCredits === 'open' ? 'close' : 'open' }
    },
    toggleDownloadReportModal(state) {
      return { ...state, downloadReport: state.downloadReport === 'open' ? 'close' : 'open' }
    },
    toggleCancelTicketModal(state) {
      return { ...state, cancelTicket: state.cancelTicket === 'open' ? 'close' : 'open' }
    },
    toggleCancelTicketByUuidModal(state) {
      return { ...state, cancelTicketByUuid: state.cancelTicketByUuid === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerSettingsModal(state) {
      return { ...state, organizerSettings: state.organizerSettings === 'open' ? 'close' : 'open' }
    },
    toggleTransactionActionModal(state) {
      return { ...state, transactionAction: state.transactionAction === 'open' ? 'close' : 'open' }
    },
    toggleDeclineRequestActionModal(state) {
      return { ...state, declineRequestAction: state.declineRequestAction === 'open' ? 'close' : 'open' }
    },
    toggleApproveRequestActionModal(state) {
      return { ...state, approveRequestAction: state.approveRequestAction === 'open' ? 'close' : 'open' }
    },
    toggleEventCrossQRScannerModal(state) {
      return { ...state, eventCrossQRScanner: state.eventCrossQRScanner === 'open' ? 'close' : 'open' }
    },
    toggleEventGiftTicketsModal(state) {
      return { ...state, eventGiftTickets: state.eventGiftTickets === 'open' ? 'close' : 'open' }
    },
    toggleChangeEventOwnerModal(state) {
      return { ...state, changeEventOwner: state.changeEventOwner === 'open' ? 'close' : 'open' }
    },
    toggleEventSettingsModal(state) {
      return { ...state, eventSettings: state.eventSettings === 'open' ? 'close' : 'open' }
    },
    toggleEventTypesModal(state) {
      return { ...state, eventTypes: state.eventTypes === 'open' ? 'close' : 'open' }
    },
    toggleChangeOwnerByLinkModal(state) {
      return { ...state, changeOwnerByLink: state.changeOwnerByLink === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerSettingsEventFeePercentModal(state) {
      return { ...state, organizerSettingsEventFeePercent: state.organizerSettingsEventFeePercent === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerFilesModal(state) {
      return { ...state, organizerFiles: state.organizerFiles === 'open' ? 'close' : 'open' }
    },
    toggleUploadOrganizerFileModal(state) {
      return { ...state, uploadOrganizerFile: state.uploadOrganizerFile === 'open' ? 'close' : 'open' }
    },
    toggleCreateTransactionModal(state) {
      return { ...state, createTransaction: state.createTransaction === 'open' ? 'close' : 'open' }
    },
    toggleBillAccountModal(state) {
      return { ...state, billAccount: state.billAccount === 'open' ? 'close' : 'open' }
    },
    toggleSendPushNotificationModal(state) {
      return { ...state, sendPushNotification: state.sendPushNotification === 'open' ? 'close' : 'open' }
    },
    toggleSendSmsBroadcastModal(state) {
      return { ...state, sendSmsBroadcast: state.sendSmsBroadcast === 'open' ? 'close' : 'open' }
    },
  },
})

export default modalsSlice.reducer
